import React, { useEffect,useState } from 'react'
import { BarChartTheme } from '../charts'
import { Dashboard } from '../../sdk'
import { Loader } from '../Default'
import moment from 'moment'
export const GraphDataForTimeInterval=()=>{
    const [state,setState]=useState({loader:true,date:moment().subtract(1,"day").format("yyyy-MM-DD"),data:[],categories:[],exitData:[],totalCount:0,totalExit:0,cameraId:"",type:""});
    const onHandler=(event)=>{
      event.preventDefault();
      let key=event.target.name;
      let value=event.target.value;
      if(key==="date"){
      value = moment(event.target.value).format("yyyy-MM-DD");
      }
     setState((pre)=>{
      return {...pre,loader:true}
     })
      apiData({date:value})
      
   }
    const apiData=async(data2)=>{
        try{
          let result=await new Dashboard().timeIntervalData(data2);
          let data=[];
          let exitData=[];
          let categories=[];
          let totalCount=0;
          let totalExit=0;
          if(result.length){
          for(let val of result){
            categories.push(val.name);
            data.push(val.total);
            exitData.push(val.totalExitCount)
            totalCount+=val.total
            totalExit+=val.totalExitCount
          }
          }
          setState((pre)=>{
          return {...pre,loader:false,data,date:data2.date,categories,totalCount,totalExit,exitData}
           })
      
        }catch(e){
    
          alert("click ok to continue")
        }
        }
       
    useEffect(()=>{
      apiData({date:state.date});
    },[])
    
        return (
            <>
            <div className="col-xl-12">
            <div className="card mb-3 lineChart">
              {/* BEGIN card-body */}
              <div className="card-body">
                {/* BEGIN title */}
                <div className="d-flex fw-bold small mb-3">
                  <div className="col-sm-3 col-md-3 col-lg-5">
                  <span className="flex-grow-1">Day Wise Counting</span>
                  </div>
                  
                  <div className="col-sm-3 col-md-3 col-lg-3" style={{textAlign:"center",font:"22px White",fontWeight:"700",color:"white"}}>
                 {state.date}
                </div>
      
        
                  <div className="col-sm-3 col-md-3 col-lg-2">
                  <div class="form-group mb-3" style={{ width: "85%" }}>
                  <label class="form-label" for="exampleFormControlSelect1">Select Date</label>
                  <input type="date" class="form-control text-white" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandler} value={state.date}/>
                </div>
                </div>
              
             
                </div>
                <div className="col-12">
                    <div className="row">
                    <div className="col-4" style={{textAlign:"center",font:"18px White",fontWeight:"400"}} >
Total Count: <span style={{font:"18px White",fontWeight:"800"}}>{state.totalCount}</span>

                  </div>
                  <div className="col-4" style={{textAlign:"center",font:"18px White",fontWeight:"400"}} >
Total Exit Count: <span style={{font:"18px White",fontWeight:"800"}}>{state.totalExit}</span>

                  </div>
                    </div>
                </div>
                  
                     {state.loader && <Loader/>}
               {!state.loader && <BarChartTheme  type="monthly" id="monthlyLineChartFootFall1" categories={state.categories} data={state.data} exitData={state.exitData}/>}   
               
               
              </div>
           
              <div className="card-arrow">
                <div className="card-arrow-top-left" />
                <div className="card-arrow-top-right" />
                <div className="card-arrow-bottom-left" />
                <div className="card-arrow-bottom-right" />
              </div>
              {/* END card-arrow */}
            </div>
                
           
            </div>
        
            </>
          )
    }
   